import { makeAutoObservable, runInAction } from 'mobx';
import LoadingService from 'src/utils/LoadingService';
import UserInfoService from 'src/utils/UserInfoService';
import { randomNumber, showContact, showError } from 'src/utils';
import { convertPolicyStatusToPolicyStatusId } from 'src/utils/Policy';
import Policy from 'src/models/Policy';
import { PaymentType, PATH, CONSTANT, OTP_TYPES } from 'src/constants';
import {
    getListAllPolicy,
    getListPeriodicPolicyByIdCard,
    getPeriodicPolicyByPolicyNum,
    getTopUpPolicyByPolicyNum,
    getPolicyToCancel,
    cancelPolicy,
    createOtp,
    getPeriodicPolicyByPolicyNumNew,
    getTopUpPolicyByPolicyNumNew,
} from 'src/api';
import { Reason } from 'src/models/Reason';

const listReason: Reason[]= [
    {
      reasonID: 'R01',
      text: "Điều kiện tài chính",
      checked: false
    },
    {
      reasonID: 'R02',
      text: "Sản phẩm không phù hợp nhu cầu",
      checked: false
    },
    {
      reasonID: 'R03',
      text: "Đã có nhiều sản phẩm bảo hiểm",
      checked: false
    },
    {
      reasonID: 'Other',
      text: "Nguyên nhân khác",
      checked: false
    }
];

export class PolicyStore {
    listPolicy: Policy[];
    policyToCancel: any;
    infoReasonCancel: any;
    verificationOtp: any;
    fromScreen: string;

    constructor() {
        makeAutoObservable(this);
    }

    async getListAllPolicy(history, fromScreen) {
        try {
            LoadingService.instance.current.open();
            let response = await getListAllPolicy(
                    UserInfoService.getUserInfo()?.idCardType ?? CONSTANT.ID_CARD_TYPE_DEFAULT,
                    UserInfoService.getUserInfo()?.idCardNo ?? CONSTANT.ID_CARD_NO_DEFAULT,
                    UserInfoService.getUserInfo()?.dob ?? CONSTANT.DOB_DEFAULT
                );
            let data = response.data.map(item => {
                return {
                    ...item,
                    bgIndex: randomNumber(0,1)
                }
            });
            LoadingService.instance.current.close();
            runInAction(() => {
                this.listPolicy = data;
                this.fromScreen = fromScreen;
            });
            if(history){
                history.push(PATH.MY_POLICY);
            }
        } catch (error) {
            LoadingService.instance.current.close();
            let errorStatus = error?.response?.status;
            if (errorStatus == 400) {
                let errorCodes = ['103', '207', '104', '001'];
                let errorCode = error?.response?.data?.error_code;
                let errorMessage = error?.response?.data?.error_message;
                if(errorCodes.includes(errorCode)){
                    showContact(errorMessage);
                }else{
                    showError(errorMessage);
                }
            }
        }
    }

    async getListPeriodicPolicyByIdCard({ idType, idNumber, history, birthDate }) {
        try {
            LoadingService.instance.current.open();
            let response = await getListPeriodicPolicyByIdCard(idType, idNumber, birthDate);
            let data = response.data.map(item => {
                return {
                    ...item,
                    bgIndex: randomNumber(0,1),
                }
            });
            LoadingService.instance.current.close();
            runInAction(() => {
                this.listPolicy = data;
            });
            history.push(PATH.POLICY_SEARCH);
        } catch (error) {
            LoadingService.instance.current.close();
            let errorStatus = error?.response?.status;
            if (errorStatus == 400) {
                let errorCodes = ['001'];
                let errorCode = error?.response?.data?.error_code;
                let errorMessage = error?.response?.data?.error_message;
                if(errorCodes.includes(errorCode)){
                    showContact(errorMessage);
                }else{
                    showError(errorMessage);
                }
            }
        }
    }

    async getPeriodicPolicy({ policyNum, bgIndex, showDetail}){
        try {
            let response = await getPeriodicPolicyByPolicyNum(policyNum);
            let data = {
                ...response.data,
                bgIndex: bgIndex ?? randomNumber(0,1),
                showDetail
            };
            if(!data.policyStatusId){
                data.policyStatusId = convertPolicyStatusToPolicyStatusId(data.policyStt);
            }
            if(data.duePremium?.length > 0){
                data.duePremium[0].checked = true;
            }
            if(!data.payFrequency){
                data.payFrequency = data.payFreqText;
            }
            if(!data.periodicPremium){
                data.periodicPremium = data.periodicPrem;
            }
            return data;
        } catch (error) {
            let errorStatus = error?.response?.status;
            if (errorStatus == 400) {
                let errorCodes = ['005', '207'];
                let errorCode = error?.response?.data?.error_code;
                let errorMessage = error?.response?.data?.error_message;
                if(errorCodes.includes(errorCode)){
                    showContact(errorMessage);
                }else{
                    showError(errorMessage);
                }
            }
            throw error;
        }
    }

    async getPeriodicPolicyNew({ policyNum, bgIndex, showDetail, birthDate}){
        try {
            let response = await getPeriodicPolicyByPolicyNumNew(policyNum, birthDate);
            let data = {
                ...response.data,
                bgIndex: bgIndex ?? randomNumber(0,1),
                showDetail
            };
            if(!data.policyStatusId){
                data.policyStatusId = convertPolicyStatusToPolicyStatusId(data.policyStt);
            }
            if(data.duePremium?.length > 0){
                data.duePremium[0].checked = true;
            }
            if(!data.payFrequency){
                data.payFrequency = data.payFreqText;
            }
            if(!data.periodicPremium){
                data.periodicPremium = data.periodicPrem;
            }
            return data;
        } catch (error) {
            let errorStatus = error?.response?.status;
            if (errorStatus == 400) {
                let errorCodes = ['005', '207'];
                let errorCode = error?.response?.data?.error_code;
                let errorMessage = error?.response?.data?.error_message;
                if(errorCodes.includes(errorCode)){
                    showContact(errorMessage);
                }else{
                    showError(errorMessage);
                }
            }
            throw error;
        }
    }

    async getTopUpPolicy({ policyNum, bgIndex, paymentType, showDetail }){
        try {
            let response = await getTopUpPolicyByPolicyNum(policyNum);
            let data = {
                ...response.data,
                bgIndex: bgIndex ?? randomNumber(0,1),
                showDetail
            };
            if(!data.policyStatusId){
                data.policyStatusId = convertPolicyStatusToPolicyStatusId(data.policyStt);
            }
            if(!data.payFrequency){
                data.payFrequency = data.paymentFreq;
            }
            if(!data.periodicPremium){
                data.periodicPremium = data.periodicPrem;
            }
            return data;
        } catch (error) {
            if(paymentType == PaymentType.TOPUP_PAYMENT) {
                let errorCodes = ['005', '207', '210'];
                let errorStatus = error?.response?.status;
                if (errorStatus == 400) {
                    let errorCode = error?.response?.data?.error_code;
                    let errorMessage = error?.response?.data?.error_message;
                    if(errorCodes.includes(errorCode)){
                        showContact(errorMessage);
                    }else{
                        if(errorCode != '209'){
                            showError(errorMessage);
                        }
                    }
                }
                throw error;
            }
        }
    }

    async getTopUpPolicyNew({ policyNum, bgIndex, paymentType, showDetail, birthDate }){
        try {
            let response = await getTopUpPolicyByPolicyNumNew(policyNum, birthDate);
            let data = {
                ...response.data,
                bgIndex: bgIndex ?? randomNumber(0,1),
                showDetail
            };
            if(!data.policyStatusId){
                data.policyStatusId = convertPolicyStatusToPolicyStatusId(data.policyStt);
            }
            if(!data.payFrequency){
                data.payFrequency = data.paymentFreq;
            }
            if(!data.periodicPremium){
                data.periodicPremium = data.periodicPrem;
            }
            return data;
        } catch (error) {
            if(paymentType == PaymentType.TOPUP_PAYMENT) {
                let errorCodes = ['005', '207', '210'];
                let errorStatus = error?.response?.status;
                if (errorStatus == 400) {
                    let errorCode = error?.response?.data?.error_code;
                    let errorMessage = error?.response?.data?.error_message;
                    if(errorCodes.includes(errorCode)){
                        showContact(errorMessage);
                    }else{
                        if(errorCode != '209'){
                            showError(errorMessage);
                        }
                    }
                }
                throw error;
            }
        }
    }

    async getPolicyToCancel({ policy, history }) {
        try {
            LoadingService.instance.current.open();
            let policyToCancel = await getPolicyToCancel({ policyNum: policy.policyNum });
            runInAction(() => {
                this.policyToCancel = {
                    ...policyToCancel.data,
                    policyNum: policy.policyNum,
                    assuredName: policy.assuredName,
                    sumAssured: policy.sumAssured,
                    listReason: [...listReason],
                };
            });
            LoadingService.instance.current.close();
            history.push(PATH.CANCEL_POLICY);
        } catch (error) {
            LoadingService.instance.current.close();
            let errorStatus = error?.response?.status;
            if (errorStatus == 400) {
                let errorMessage = error?.response?.data?.error_message;
                showContact(errorMessage);
            }
        }
    }

    async cancelPolicy({ params, history }) {
        try {
            LoadingService.instance.current.open();
            let response = await cancelPolicy(params);
            runInAction(() => {
                this.policyToCancel = {
                    ...this.policyToCancel,
                    terEffectiveDate: response.data?.terEffectiveDate
                };
            });
            LoadingService.instance.current.close();
            history.push(PATH.COMPLETE_CANCEL_POLICY);
        } catch (error) {
            LoadingService.instance.current.close();
            let errorStatus = error?.response?.status;
            if (errorStatus == 400) {
                let otpErrorCodes = ["MSG03", "MSG12"];
                let errorCode = error?.response?.data?.error_code;
                let errorMessage = error?.response?.data?.error_message;
                if(otpErrorCodes.includes(errorCode)){
                    throw errorMessage;
                }else{
                    showContact(errorMessage);
                }
            }
        }
    }

    async _createOtp({ type, policyNumber }) {
        try {
            LoadingService.instance.current.open();
            const createOtpRes = await createOtp(
                UserInfoService.getUserInfo()?.idCardNo || "",
                UserInfoService.getUserInfo()?.mobile || "",
                type,
                policyNumber,
            );
            LoadingService.instance.current.close();
            runInAction(() => {
                this.verificationOtp = {
                    requestId: createOtpRes?.data?.requestId,
                }
            });
            return true;
        } catch (error) {
            LoadingService.instance.current.close();
            let errorStatus = error?.response?.status;
            if (errorStatus == 400) {
                let errorMessage = error?.response?.data?.error_message;
                showError(errorMessage);
            }
            throw error;
        }
    }

    async setInfoReasonCancelAndCreateOtp({ infoReasonCancel, history }) {
        await this._createOtp({ type: OTP_TYPES.CANCEL_POLICY,policyNumber: infoReasonCancel.policyNum  });
        runInAction(() => {
            this.infoReasonCancel = {
                ...infoReasonCancel,
            };
        });
        history.push(PATH.OTP_CANCEL_POLICY);
    }

}

export default new PolicyStore();
